import methods from './methods'
import props from './props'

export default {
  methods,
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/links-profile/resources/index.js